// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2Wrne","noticePeriodLabel":"Label_noticePeriodLabel__2UCpJ","float":"Label_float__2NA0z"};